import React, { useState } from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theme';
import { StyledBreadcrumbs } from '../WindowedCategoryPage';
import { JournalNavigation } from './JournalNavigation';
import { JournalPostsList } from './JournalPostsList';

const Wrapper = styled('div')`
  width: 100%;
  max-width: 80rem;
  margin: 0 auto 40px auto;
  padding: 0 2rem;

  .header-wrapper {
    margin-top: 14px;

    h1 {
      font-family: ${theme.fonts.primaryFontFamily};
      font-weight: 700;
      font-size: 43px;
      line-height: 52px;
      margin: 0;
      color: #282828;
    }

    ${theme.below.lg} {
      padding: 0 20px;
      h1 {
        font-size: 28px;
        line-height: 34px;
      }
    }
  }

  ${theme.below.lg} {
    padding: 0;
  }
`;

const JournalList = ({ category, breadcrumbProps }) => {
  const [activeSubCategory, setActiveSubCategory] = useState('all');
  return (
    <Wrapper>
      <div className="header-wrapper">
        <StyledBreadcrumbs {...breadcrumbProps} />
        <h1>{category?.mainHeader}</h1>
      </div>
      <JournalNavigation
        subCategories={category?.subcategories}
        activeSubCategory={activeSubCategory}
        setActiveSubCategory={setActiveSubCategory}
      />
      <JournalPostsList
        subCategories={category?.subcategories}
        activeSubCategory={activeSubCategory}
      />
    </Wrapper>
  );
};

export default JournalList;
